export default {
  "--color-neutral-0": "rgb(255, 255, 255)",
  "--color-neutral-10": "rgb(228, 228, 231)",
  "--color-neutral-20": "rgb(201, 201, 207)",
  "--color-neutral-30": "rgb(174, 174, 183)",
  "--color-neutral-40": "rgb(147, 147, 159)",
  "--color-neutral-50": "rgb(120, 120, 135)",
  "--color-neutral-60": "rgb(108, 108, 122)",
  "--color-neutral-70": "rgb(96, 96, 108)",
  "--color-neutral-80": "rgb(72, 72, 81)",
  "--color-neutral-85": "rgb(58, 58, 65)",
  "--color-neutral-90": "rgb(48, 48, 54)",
  "--color-neutral-95": "rgb(38, 38, 43)",
  "--color-neutral-100": "rgb(34, 34, 38)",
  "--color-primary": "rgb(114, 136, 218)",
  "--color-primary-active": "rgb(102, 126, 214)",
  "--color-primary-inverse": "rgb(247, 248, 253)",
  "--color-secondary": "rgb(63, 171, 123)",
  "--color-secondary-active": "rgb(76, 189, 138)",
  "--color-secondary-inverse": "rgb(248, 252, 250)",
  "--color-success": "rgb(79, 172, 32)",
  "--color-success-active": "rgb(88, 194, 36)",
  "--color-success-inverse": "rgb(249, 253, 246)",
  "--color-danger": "rgb(230, 36, 25)",
  "--color-danger-active": "rgb(233, 62, 53)",
  "--color-danger-inverse": "rgb(254, 246, 246)",
  "--color-warning": "rgb(230, 121, 25)",
  "--color-warning-active": "rgb(233, 137, 53)",
  "--color-warning-inverse": "rgb(254, 250, 246)",
  "--color-yellow": "rgb(245, 196, 0)",
  "--color-yellow-active": "rgb(255, 206, 10)",
  "--color-yellow-inverse": "rgb(255, 253, 245)",
  "--text-color-base": "rgb(228, 228, 231)",
  "--text-color-soft": "rgb(174, 174, 183)",
  "--text-color-softer": "rgb(120, 120, 135)",
  "--text-color-disabled": "rgb(120, 120, 135)",
  "--text-color-inverse": "rgb(38, 38, 43)",
  "--text-color-link": "rgb(114, 136, 218)",
  "--text-color-link-active": "rgb(102, 126, 214)",
  "--text-color-primary": "rgb(114, 136, 218)",
  "--text-color-primary-inverse": "rgb(247, 248, 253)",
  "--text-color-secondary": "rgb(63, 171, 123)",
  "--text-color-secondary-inverse": "rgb(248, 252, 250)",
  "--text-color-success": "rgb(79, 172, 32)",
  "--text-color-success-inverse": "rgb(249, 253, 246)",
  "--text-color-warning": "rgb(230, 121, 25)",
  "--text-color-warning-inverse": "rgb(254, 250, 246)",
  "--text-color-danger": "rgb(230, 36, 25)",
  "--text-color-danger-inverse": "rgb(254, 246, 246)",
  "--background-color-base": "rgb(34, 34, 38)",
  "--background-color-soft": "rgb(38, 38, 43)",
  "--background-color-softer": "rgb(48, 48, 54)",
  "--background-color-softer-active": "rgb(38, 38, 43)",
  "--background-color-softest": "rgb(58, 58, 65)",
  "--background-color-softest-active": "rgb(48, 48, 54)",
  "--background-color-inverse": "rgb(255, 255, 255)",
  "--background-color-inverse-soft": "rgb(228, 228, 231)",
  "--background-color-inverse-softer": "rgb(201, 201, 207)",
  "--background-color-inverse-softer-active": "rgb(174, 174, 183)",
  "--background-color-primary": "rgb(114, 136, 218)",
  "--background-color-primary-active": "rgb(102, 126, 214)",
  "--background-color-primary-inverse": "rgb(247, 248, 253)",
  "--background-color-secondary": "rgb(63, 171, 123)",
  "--background-color-secondary-active": "rgb(76, 189, 138)",
  "--background-color-secondary-inverse": "rgb(248, 252, 250)",
  "--background-color-success": "rgb(79, 172, 32)",
  "--background-color-success-active": "rgb(88, 194, 36)",
  "--background-color-success-inverse": "rgb(249, 253, 246)",
  "--background-color-warning": "rgb(230, 121, 25)",
  "--background-color-warning-active": "rgb(233, 137, 53)",
  "--background-color-warning-inverse": "rgb(254, 250, 246)",
  "--background-color-danger": "rgb(230, 36, 25)",
  "--background-color-danger-active": "rgb(233, 62, 53)",
  "--background-color-danger-inverse": "rgb(254, 246, 246)",
  "--border-color-base": "rgb(108, 108, 122)",
  "--border-color-soft": "rgb(96, 96, 108)",
  "--border-color-softer": "rgb(72, 72, 81)",
  "--border-color-active": "rgb(114, 136, 218)",
  "--border-color-primary": "rgb(114, 136, 218)",
  "--border-color-success": "rgb(79, 172, 32)",
  "--border-color-warning": "rgb(230, 121, 25)",
  "--border-color-danger": "rgb(230, 36, 25)",
  "--font-family-heading": "Whitney,Helvetica Neue,Helvetica,Arial,sans-serif",
  "--font-family-text": "Whitney,Helvetica Neue,Helvetica,Arial,sans-serif",
  "--font-family-code": "inconsolata, monospace",
  "--font-weight-regular": "normal",
  "--font-weight-bold": "700",
  "--box-shadow-large": "0 20px 60px 0 rgba(0, 0, 0, .5)",
  "--box-shadow-base": "0px 12px 26px -4px rgba(0, 0, 0, .5)",
  "--box-shadow-small": "0px 8px 18px -2px rgba(0, 0, 0, .5)",
  "--box-shadow-x-small": "0px 0px 3px 0px rgba(0, 0, 0, .5)",
  "--box-shadow-active": "0 0 6px 1px rgba(20, 100, 160, 0.5)",
  "--box-shadow-inset": "inset 0 0 20px 1px rgba(0,0,0,.15)",
  "--box-shadow-small-inset": "inset 0 0 0 1px rgba(0,0,0,.05)"
}